import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { getImgSrc } from "../../services/common/CommonUtils";
const BannersComponent = ({ type, data, showBgColor }) => {
  const {
    appData: { themeColor },
  } = useSelector((state) => state);

  if (type === 1) {
    return (
      <div
        className="sub_banner_comp"
        style={{ backgroundColor: data?.bgcolor || '#ffffff' }}
      >
        <div className="sub_banner_comp_container">
          <div className="sub_banner_text">
            <h3>{data?.name}</h3>
          </div>
          <div className="sub_banner_img">
            <img src={data?.image} alt="" title="" />
          </div>
        </div>
      </div>
    );
  }

  if (type === 2) {
    //console.log(data, "dateser")
    return (
      <div className="sub_full_bg_banner_comp" style={{backgroundColor: showBgColor ? themeColor : ''}}>
        <div className="banner_icon">
          <div className="offer">
            <img
              src={process.env.PUBLIC_URL + "/assets/images/start.svg"}
              alt=""
              title=""
            />
          </div>
          <img
            // src= {data?.imageurl !== null ? data?.imageurl : process.env.PUBLIC_URL + "/assets/images/s-internet.svg"}
            src={getImgSrc(data?.imageurl, true)}
            alt=""
            title=""
          />
        </div>
      </div>
    );
  }

  if (type === 3) {
    return (
      <div className="sub_banner_comp">
        <div className="sub_banner_comp_container">
          <div className="sub_banner_text">
            <h4>Get a FREE subscription after five purchases</h4>
            <p className="support_text text-uppercase mb-0 mt-2">
              1 Purchase = 1 Badge
            </p>
          </div>
          <div className="sub_banner_img">
            <img
              src={
                process.env.PUBLIC_URL +
                "/assets/images/banners-special-deals.png"
              }
              alt=""
              title=""
            />
          </div>
        </div>
      </div>
    );
  }

  if (type === 4) {
    return (
      <div className="sub_banner_comp turquoise_bg">
        <div className="sub_banner_comp_container">
          <div className="sub_banner_text">
            <h3>Roaming</h3>
          </div>
          <div className="sub_banner_img">
            <img
              src={
                process.env.PUBLIC_URL + "/assets/images/Banners_Bundles@2x.png"
              }
              alt=""
              title=""
            />
          </div>
        </div>
      </div>
    );
  }
  if (type === 5) {
    return (
      <div className='banner_section_new banner_margin'  style={{ backgroundColor: data?.bgcolor || '#ffffff' }}>
        <div className='banners_item'>
            <h3>{data?.name}</h3>
            <div className='img_cont'>
              <img src={data?.image} alt="" title="" />
            </div>
        </div>
    </div>
    );
  }
};
export default BannersComponent;
